module.exports = __webpack_public_path__ + "static/img/1.47fc4eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shao/1.jpg
// module id = MfNF
// module chunks = 1